import React, { ReactElement, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import isEqual from 'lodash.isequal';
import { TOAST_TYPE } from 'b2b-apps/shop/common/components/Toast';
import { showToast } from 'b2b-apps/shop/common/utils/showToast';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { useProductReportErrorEffect } from 'b2b-apps/shop/product/hooks';
import {
  EnhancedComponentProps,
  EnhancedComponentType,
  FormValuesType,
  InjectedProps,
  WrappedComponentType,
} from './';

const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const t = useTranslate();
    const {
      onFormHide,
    } = props;
    const {
      data,
      reportProductError,
      clearReportProductError,
    } = useProductReportErrorEffect();
    const { sku } = useParams<{ sku: string }>();
    const { wasStarted, isLoading, isLoaded, hasFailed } = data;


    useEffect(
      () => () => {
        clearReportProductError();
      },
      [clearReportProductError],
    );


    useEffect(
      () => {
        if (isLoaded && !hasFailed) {
          showToast(
            TOAST_TYPE.success,
            null,
            t('Error in product reported successfully'),
          );
          clearReportProductError();
          onFormHide();
        }
      },
      [
        isLoaded,
        hasFailed,
        clearReportProductError,
        onFormHide,
        t,
      ],
    );

    const handleSubmit = useCallback(
      (values: FormValuesType) => {
        reportProductError({
          ...values,
          sku,
          path: window.location.href,
        });
      },
      [
        reportProductError,
        sku,
      ],
    );

    const injectedProps: InjectedProps = {
      onSubmit: handleSubmit,
      isSubmitting: wasStarted && isLoading,
      hasSubmissionFail: hasFailed,
    };

    return <Component {...props} {...injectedProps} />;
  };

  return React.memo(WithContainer, (prevProps, nextProps) => isEqual(prevProps, nextProps));
};

export { withContainer };
